/* eslint-disable no-underscore-dangle */
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import ElementBaseModel from './element-base-model';
import { INoteBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/note-model.interface';
import { DataType, STPlaceholderType, IShapeData, ISlideDataModel, IShapeDataModel, INoteSlideData } from '@tencent/slide-sdk-model';
import { generate } from 'shortid';
import ShapeModel from '@src/slide/domain/ui-model/element-modeles/shape-model';
import { ShapePropertyConverter } from '@src/slide/domain/ui-model/converter/node-property/element/shape-property-converter';
import { IParagraph } from '@src/slide/domain/ui-model/element-modeles/property/text/interface/editor-para.interface';

class NoteBaseModel extends ElementBaseModel implements INoteBaseModel {
    public constructor(props?) {
        super(props);
        this.type = UIModelType.NOTE;
    }

    public updateNoteText(paragraphTexts: string[]) {
        const paragraphList = this.getParagraphListFromTexts(paragraphTexts);
        this.updateParagraphList(paragraphList, {});
    }

    public updateParagraphList(paragraphList, textBodyStyle) {
        // 当前备注从属的slide sdk
        const slideSdk = this.parent?.sdkData as ISlideDataModel;
        if (!slideSdk) {
            return;
        }

        // 将paragraphList转换成sdk格式
        const shapeModel = new ShapeModel();
        shapeModel.paragraphList = paragraphList;
        shapeModel.textBodyStyle = textBodyStyle;
        const shapeSdkData: IShapeData = {
            id: generate(),
            type: DataType.Shape,
            nvPr: { ph: { type: STPlaceholderType.body } },
            spPr: {},
        };
        ShapePropertyConverter.convertPartialDataFromUiToSdk(shapeModel, shapeSdkData, shapeModel);

        if (this.sdkData) {
            // 已存在备注的sdk数据了，则直接更新文本即可
            const noteSdk = slideSdk.getNoteSlide()?.note;
            if (noteSdk && shapeSdkData.txBody?.p) {
                (noteSdk as IShapeDataModel).api.updateParagraphList(shapeSdkData.txBody.p);
            } else {
                slideSdk.getNoteSlide()?.api.addShapes([shapeSdkData]);
            }
        } else {
            // 还没创建关联sdk数据，则新建一个sdk数据
            const sdkData: INoteSlideData = {
                id: generate(),
                type: DataType.Notes,
                slideId: slideSdk.id,
                cSld: {
                    spTree: {
                        id: generate(),
                        type: DataType.GroupShape,
                        nvPr: {},
                        spPr: {},
                        shapeList: [shapeSdkData],
                    },
                },
            };
            slideSdk.api.addNoteSlide(sdkData);
        }
    }

    public prepareSDKParagraphListData(paragraphList): any {
        const uiModel = {
            noteTextBody: {
                paragraphList,
            },
        };
        const sdkData = {};
        Object.getPrototypeOf(this).constructor.convertDataUiToSdk(uiModel, sdkData, this);
        return sdkData;
    }

    private getParagraphListFromTexts(texts: string[]): IParagraph[] {
        return texts.map(text => ({
            textRuns: [{
                text,
            }],
        }));
    }
}

export default NoteBaseModel;
